module.exports = __webpack_public_path__ + "img/footer-icon-2-1.7fafa55.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/footer-icon-2-1.jpeg
// module id = 0wpx
// module chunks = 1